<ng-template #ngContent>
  <ng-content></ng-content>
</ng-template>

@if (!loading) {
  <button [type]="type"
          [attr.id]="id"
          [disabled]="disabled"
          class="button"
          [class]="getButtonClass()"
          [class.disabled]="disabled"
          (click)="onClick($event)">
    <ng-container *ngTemplateOutlet="ngContent"/>
  </button>
} @else {
  <button class="spinner"
          [class]="getButtonClass()"
          [type]="type" disabled>
    <span [class]="getSpinnerClass()" aria-hidden="true"></span>
    <span role="status">
      <ng-container *ngTemplateOutlet="ngContent"/>
    </span>
  </button>
}
